module.exports = __webpack_public_path__ + "img/about-1.c529cecc.png";